import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable/styles';
import { infoSectionTitleStyles } from '@/components/Approval/@components/InfoSection/styles';

/** 저장 HTML(레거시 문서 포함)의 클래스로 맞춤. 변경 표시 빨간 글씨는 인라인 style */
export const SerpStoreChangeRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& h2': {
    ...infoSectionTitleStyles,
    margin: '0 0 8px',
  },
  '& table': {
    ...approvalFormTableStyles(theme),
    tableLayout: 'auto',
    minWidth: 720,
  },
  '& table th, & table td': {
    textAlign: 'center',
  },
  '& table th': {
    wordBreak: 'keep-all',
  },
  '& tr.text-left td': {
    textAlign: 'left',
  },
  '& ul': {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
}));
